import { getSpace } from '../../../foundation/theme/space.utils';
import { getFontSize } from '../../../foundation/theme/typography.utils';
export const TABLE_DEFAULT_BORDER_TYPE = 'full';
export const TABLE_DEFAULT_WIDTH = 'full';
export const TABLE_DEFAULT_SIZE = 's';
export const TABLE_DEFAULT_ZEBRA = false;
/** Size mappings. */
export const MAPPINGS_SIZE = {
    s: {
        fontSize: getFontSize('s'),
        padding: `${getSpace('xl')} ${getSpace('l')}`
    },
    xs: {
        fontSize: getFontSize('xs'),
        padding: `${getSpace('l')} ${getSpace('m')}`
    }
};
//# sourceMappingURL=Table.constants.js.map